import { useState } from "react";
import { toast } from "sonner";
import { CalendarCheck, Loader2, Plus, Trash2 } from "lucide-react";
import { addVisit, deleteVisit } from "@/lib/bf";
import { DAYS } from "./BFClientFields";
import BFClientNext from "./BFClientNext";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" });
const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("ro-RO", { weekday: "short", day: "numeric", month: "long", year: "numeric" });

export default function BFClientVisits({ id, v, set, visits, setVisits }) {
  const [date, setDate] = useState(today());
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const add = () => {
    setBusy(true);
    addVisit(id, { date, note }).then((d) => { setVisits((l) => [d, ...l].sort((a, b) => b.date.localeCompare(a.date))); setNote(""); toast.success("Vizită notată"); })
      .catch(() => toast.error("Nu am putut nota vizita")).finally(() => setBusy(false));
  };
  const del = (x) => deleteVisit(id, x.id).then(() => setVisits((l) => l.filter((y) => y.id !== x.id))).catch(() => toast.error("Nu am putut șterge"));
  return (
    <section className="invite-box bfc-sec" data-testid="bfc-visits">
      <h3><CalendarCheck size={16} /> Vizite</h3>
      <div className="bfc-grid">
        <label className="st-field bfc-f"><span className="st-label">Ziua de vizită</span>
          <select value={v.visit_day || ""} onChange={(e) => set("visit_day", e.target.value)} data-testid="bfc-visit_day">{DAYS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
        <label className="st-field bfc-f"><span className="st-label">Cât de des</span>
          <select value={v.visit_every || 1} onChange={(e) => set("visit_every", Number(e.target.value))} data-testid="bfc-visit_every">
            {[1, 2, 3, 4, 8].map((n) => <option key={n} value={n}>{n === 1 ? "în fiecare săptămână" : `la ${n} săptămâni`}</option>)}
          </select></label>
      </div>
      <div className="bfc-visit-new">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="bfc-visit-date" />
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Ce s-a discutat, ce a comandat, ce urmează" data-testid="bfc-visit-note" />
        <button type="button" className="st-btn st-btn--light" onClick={add} disabled={busy || !date} data-testid="bfc-visit-add">{busy ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Notează vizita</button>
      </div>
      <BFClientNext id={id} />
      {!visits.length && <p className="st-hint" data-testid="bfc-visits-empty">Nicio vizită notată încă.</p>}
      <ul className="bfc-visits">
        {visits.map((x) => (
          <li key={x.id} data-testid={`bfc-visit-${x.id}`}>
            <b>{fmt(x.date)}{x.via === "ruta" && <em className="bfc-via">din rută</em>}</b><span>{x.note || "—"}</span><small>{x.by}</small>
            <button type="button" onClick={() => del(x)} aria-label="Șterge vizita" data-testid={`bfc-visit-del-${x.id}`}><Trash2 size={14} /></button>
          </li>
        ))}
      </ul>
    </section>
  );
}
